import React, { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Nav.css";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import ContactForm from "../ContactForm/ContactFormModal.js";

function Footer() {
    const [showContactForm, setShowContactForm] = useState(false);

    const handleGetStartedClick = (e) => {
        e.preventDefault();
        setShowContactForm(true);
    };

    const handleCloseContactForm = () => {
        setShowContactForm(false);
    };

    return (
        <div className="footer-wrapper" style={{ position: 'relative', paddingTop: '120px' }}>
            {/* Free Consultation Section - Half In/Half Out */}
            <div className="container" style={{ position: 'relative', zIndex: 10, marginBottom: '-120px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="bg-white p-4 p-md-5 rounded-4" style={{
                            borderTop: '10px solid #0d6efd',
                            position: 'relative',
                            marginTop: '-100px',
                            marginBottom: '50px',
                            boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
                            borderBottomLeftRadius: '0',
                            borderBottomRightRadius: '0'
                        }}>
                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                                <div className="text-center text-md-start mb-4 mb-md-0">
                                    <h3 className="mb-0" style={{ fontSize: '1.5rem', color: '#4a5568' }}>Ready to simplify your U.S. bookkeeping and tax compliance?</h3>
                                </div>
                                <div>
                                    <button 
                                        onClick={handleGetStartedClick}
                                        className="btn btn-lg px-5"
                                        style={{ 
                                            fontWeight: '600',
                                            borderRadius: '50px',
                                            padding: '10px 30px',
                                            backgroundColor: '#ff6b00',
                                            borderColor: '#ff6b00',
                                            color: 'white',
                                            boxShadow: '0 4px 15px rgba(255, 107, 0, 0.3)',
                                            whiteSpace: 'nowrap',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.backgroundColor = '#e65c00';
                                            e.currentTarget.style.borderColor = '#e65c00';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.backgroundColor = '#ff6b00';
                                            e.currentTarget.style.borderColor = '#ff6b00';
                                        }}
                                    >
                                        Book a free consultation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer */}
            <footer className="footer bg-primary text-light" style={{ 
                paddingTop: '150px',
                position: 'relative',
                zIndex: 1,
                marginTop: '0'
            }}>
                <div className="container">
                    <div className="row">
                        {/* Contact Info with Logo */}
                        <div className="col-md-6 mb-4 text-left text-md-left">
                            <div className="d-flex align-items-center">
                                <a href="/" className="me-3">
                                    <img 
                                        src="/logo192.png" 
                                        alt="BooksComply Logo" 
                                        style={{ width: '50px', height: '50px' }}
                                    />
                                </a>
                                <div>
                                    <h2 className="mb-0"><a href="/" className="text-white text-decoration-none">BooksComply</a></h2>
                                    <a href="mailto:contact@BooksComply.com" className="text-white">contact@BooksComply.com</a>
                                </div>
                            </div>
                        </div>

                        {/* Services */}
                        <div className="col-md-2 mb-4 text-left text-md-left">
                            <h6 className="font-weight-bold">SERVICES</h6>
                            <ul className="list-unstyled">
                                <li><a href="/bookkeeping" className="text-white">Bookkeeping</a></li>
                                <li><a href="/cfo-advisory" className="text-white">CFO Advisory</a></li>
                                <li><a href="/tax-return" className="text-white">Tax Return</a></li>
                                <li><a href="/usa-company-formation" className="text-white">USA Company Formation</a></li>
                                <li><a href="/zoho-advisory" className="text-white">Zoho Advisory</a></li>
                            </ul>
                        </div>

                        {/* Resources */}
                        <div className="col-md-2 mb-4 text-left text-md-left">
                            <h6 className="font-weight-bold">RESOURCES</h6>
                            <ul className="list-unstyled">
                                <li><a href="/blog" className="text-white">Blog</a></li>
                                <li><a href="/events/zoho-books-ahmedabad" className="text-white">Events</a></li>
                                <li><a href="/help" className="text-white">Help Center</a></li>
                                <li><a href="/why-bookscomply" className="text-white">Why BooksComply</a></li>
                            </ul>
                        </div>

                        {/* Legal */}
                        <div className="col-md-2 mb-4 text-left text-md-left">
                            <h6 className="font-weight-bold">LEGAL</h6>
                            <ul className="list-unstyled">
                                <li><a href="/privacy-policy" className="text-white">Privacy Policy</a></li>
                                <li><a href="/subscription-agreement" className="text-white">Subscription Agreement</a></li>
                            </ul>
                        </div>
                    </div>
                    
                    {/* Social Media Icons */}
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="d-flex justify-content-start justify-content-md-end" style={{ gap: '15px' }}>
                                <a href="https://www.linkedin.com/company/njpglobal/" target="_blank" rel="noopener noreferrer" className="text-white">
                                    <FaLinkedin size={24} />
                                </a>
                                <a href="https://x.com/NJP_Advisors/" target="_blank" rel="noopener noreferrer" className="text-white">
                                    <FaTwitter size={24} />
                                </a>
                                <a href="https://www.instagram.com/bookscomply/" target="_blank" rel="noopener noreferrer" className="text-white">
                                    <FaInstagram size={24} />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="row mt-3 pt-3 border-top border-light">
                        <div className="col-12 text-center">
                            <p className="mb-2">
                                &copy; {new Date().getFullYear()} NJP Global Services Pvt. Ltd. All Rights Reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
            {showContactForm && <ContactForm onClose={handleCloseContactForm} />}
        </div>
    );
}

export default Footer;